import type { BrandAssetBuilderBulletStyle } from 'src/secret-menu/brand-asset-builder/types';

// Plain Unicode punctuation, not Wingdings/Symbol private-use glyphs - every one of these renders
// correctly in any font, so the generated docx doesn't need a per-level font override to display
// the marker correctly (unlike Word's own "Bullets" gallery, which relies on Wingdings/Symbol).
//
// None of these codepoints are in the Unicode emoji set. Emoji-capable characters such as the
// card-suit diamond (U+2666) or black small square (U+25AA) fall back to Apple Color Emoji on
// macOS when the document font lacks them, rendering as a fixed-colour emoji (a red diamond) that
// ignores the bullet colour entirely.
export const BULLET_STYLE_GLYPHS: Record<BrandAssetBuilderBulletStyle, string> = {
  disc: '•',
  square: '■',
  circle: '○',
  diamond: '◆',
  dash: '–',
};

export const BULLET_STYLE_OPTIONS: { value: BrandAssetBuilderBulletStyle; label: string }[] = [
  { value: 'disc', label: BULLET_STYLE_GLYPHS.disc },
  { value: 'square', label: BULLET_STYLE_GLYPHS.square },
  { value: 'circle', label: BULLET_STYLE_GLYPHS.circle },
  { value: 'diamond', label: BULLET_STYLE_GLYPHS.diamond },
  { value: 'dash', label: BULLET_STYLE_GLYPHS.dash },
];
